import React, { useState } from 'react';
import { Modal } from './Modal';
import { TaskList } from './TaskList';
import { ConditionsPanel } from './ConditionsPanel';
import type { Loan } from '../data/loanData';
import { formatCurrency } from '../data/mockData';
const tabs = ['Overview', 'Tasks', 'Conditions & docs'] as const;
type Tab = (typeof tabs)[number];
type LoanModalProps = {
  loan: Loan | null;
  onClose: () => void;
};
function Field({
  label,
  value
}: {
  label: string;
  value: string;
}) {
  return <div data-id="element-142" data-mp="1q96su0xtgsvo">
      <dt className="text-[11px] uppercase tracking-wide text-gray-400" data-id="element-143" data-mp="1q9ydwhtsf87p">{label}</dt>
      <dd className="mt-0.5 text-[13px] text-ink" data-id="element-144" data-mp="1ci1o4kfldaeh">{value}</dd>
    </div>;
}
export function LoanModal({
  loan,
  onClose
}: LoanModalProps) {
  const [tab, setTab] = useState<Tab>('Overview');
  return <Modal open={Boolean(loan)} onClose={onClose} title={loan ? loan.borrower : ''} subtitle={loan ? `${loan.number} · ${loan.state} · ${formatCurrency(loan.amount)} · ${loan.stage}` : undefined} footer={<div className="flex flex-wrap gap-2" data-id="element-146" data-mp="323a7zrpn7qal">
          <button type="button" className="rounded-lg bg-brand px-3 py-2 text-[12.5px] font-semibold text-white transition-colors hover:bg-brand-dark" data-id="element-147" data-mp="2y4kkh6aw4sd8">
            Log activity
          </button>
          <button type="button" className="rounded-lg border border-gray-200 bg-white px-3 py-2 text-[12.5px] font-medium text-ink transition-colors hover:bg-gray-50" data-id="element-148" data-mp="372wlm29dv8jx">
            Message borrower
          </button>
        </div>} data-id="element-145" data-mp="256z6enjsz778">
      {loan && <>
          <div className="flex gap-1 border-b border-gray-200 px-4" data-id="element-149" data-mp="3ut8xfo7r1pfs">
            {tabs.map(item => <button key={item} type="button" onClick={() => setTab(item)} aria-current={tab === item} className={['-mb-px border-b-2 px-3 py-2.5 text-[12.5px] font-medium transition-colors', tab === item ? 'border-brand text-brand' : 'border-transparent text-gray-500 hover:text-ink'].join(' ')} data-id="element-150" data-mp="3psupe665efhr">
                {item}
              </button>)}
          </div>

          <div className="px-5 py-4" data-id="element-151" data-mp="dem3doyde0iy">
            {tab === 'Overview' && <dl className="grid grid-cols-2 gap-4" data-id="element-152" data-mp="id5l1d5xkq5i">
                <Field label="Loan number" value={loan.number} data-id="element-153" data-mp="iajftk6iimqg" />
                <Field label="Stage" value={loan.stage} data-id="element-154" data-mp="nafm5q2omq96" />
                <Field label="Loan amount" value={formatCurrency(loan.amount)} data-id="element-155" data-mp="s2gxn9s10cy5" />
                <Field label="Processor" value={loan.processor} data-id="element-156" data-mp="s4t8z43a3p28" />
                <Field label="Target closing" value={loan.closingDate} data-id="element-157" data-mp="x08nzzd0vr08" />
                <Field label="Days in stage" value={`${loan.daysInStage} ${loan.daysInStage === 1 ? 'day' : 'days'}${loan.stalled ? ' · stalled' : ''}`} data-id="element-158" data-mp="113wu0dm0aejd" />
                <div className="col-span-2 rounded-xl border border-gray-200 p-3.5" data-id="element-159" data-mp="2qi66873ryart">
                  <p className="text-[12.5px] font-semibold text-ink" data-id="element-160" data-mp="2ljmlga0x3511">Condition summary</p>
                  <p className="mt-1 text-[12.5px] text-gray-600" data-id="element-161" data-mp="2hkdt99lizf7l">
                    {loan.conditions.filter(c => c.status === 'Outstanding').length}{' '}
                    outstanding ·{' '}
                    {loan.conditions.filter(c => c.status === 'AI Matched').length} awaiting
                    review ·{' '}
                    {loan.conditions.filter(c => c.status === 'Accepted').length} cleared
                  </p>
                </div>
              </dl>}

            {tab === 'Tasks' && <TaskList tasks={loan.tasks} data-id="element-162" data-mp="2vj3oejosb4tb" />}

            {tab === 'Conditions & docs' && <ConditionsPanel conditions={loan.conditions} data-id="element-163" data-mp="3t0atvv2q7nkn" />}
          </div>
        </>}
    </Modal>;
}